import { useState, useEffect } from "react";

const systemPref = () => (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light");

// App-wide theme with three modes: 'light', 'dark', or 'system' (follows the OS live).
export function useTheme() {
  const [mode, setMode] = useState(() => localStorage.getItem("hs_theme_mode") || localStorage.getItem("hs_theme") || "dark");
  useEffect(() => {
    const apply = () => document.documentElement.classList.toggle("dark", (mode === "system" ? systemPref() : mode) === "dark");
    apply();
    try { localStorage.setItem("hs_theme_mode", mode); } catch { /* ignore */ }
    if (mode === "system" && window.matchMedia) {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      mq.addEventListener("change", apply);
      return () => mq.removeEventListener("change", apply);
    }
  }, [mode]);
  const cycle = () => setMode((m) => (m === "light" ? "dark" : m === "dark" ? "system" : "light"));
  return { mode, cycle, setMode };
}
